module.exports = __webpack_public_path__ + "static/media/screenshot-submission-main-page.c006e5a2.png";